import React, { useMemo, useState, useEffect } from "react"
import { Table, Row, Col, Card, CardBody, Modal, Form } from "reactstrap"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
import { useNavigate } from "react-router-dom"
import "../../../assets/css/Settings/Setting.css"
import axios from "axios"
import Loader from "pages/Separate/Loader"
import InfoGif from "../../../assets/images/GIF/question-mark.gif"
import departmentImg from "../../../assets/images/department.jpg"
import EditDepartment from "../../../assets/images/EditDepartment.jpg"
import Swal from "sweetalert2"
import configure from "configure"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import NewPagination from "components/Common/Newpagination"

const Department = () => {
  const [add_modal, setAddModal] = useState(false)
  const [edit_modal, setEditModal] = useState(false)
  const [fixedContent, setFixedContent] = useState(false)
  const [fixedSideImg, setFixedSideImg] = useState(false)
  const [view_modal, setViewModal] = useState(false)
  const [modal_Access, setAccessDenied] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [overheadModal, setOverheadModal] = useState(false)
  const [deptUsers, setDeptUsers] = useState([])
  const [loadingUsers, setLoadingUsers] = useState(false)
  const [addOverhead, setAddOverhead] = useState(0)
  const [editOverhead, setEditOverhead] = useState(0)
  const [pendingDept, setPendingDept] = useState(null) // { id, name, overhead }

  const navigate = useNavigate()

  document.addEventListener("scroll", () => {
    const scrollThreshold = window.innerHeight * 0.25
    if (window.scrollY > scrollThreshold) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })

  document.addEventListener("scroll", () => {
    if (window.scrollY > 100) {
      setFixedSideImg(true)
    } else {
      setFixedSideImg(false)
    }
  })
  console.log("ScrollY", window.scrollY)

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  function tog_center() {
    setAddModal(false)
    setEditModal(false)
    removeBodyCss()
  }

  const [department, setDepartment] = useState("")
  const [updateDepartment, setUpdateDepartment] = useState("")
  const [departmentId, setDepartmentId] = useState("")

  const openOverheadUsers = async (deptId, overheadVal, useIndividual = false) => {
    setOverheadModal(true)
    setLoadingUsers(true)
    setDeptUsers([])
    try {
      const res = await axios({
        method: "get",
        url: `${configure.nodeApi}/allUsers/getByDepartment/${deptId}`,
        headers: { Accept: "application/json" },
      })
      const fetched = useIndividual
        ? (res.data?.data || [])
        : (res.data?.data || []).map(u => ({ ...u, overhead: overheadVal }))
      setDeptUsers(fetched)
    } catch (err) {
      console.log(err)
    }
    setLoadingUsers(false)
  }

  const columns = useMemo(
    () => [
      {
        Header: "Sr. No.",
        accessor: "id",
        isShortIcon: true,
        className: "department_id text-center",
      },
      {
        Header: "Department Name",
        accessor: "department_name",
        isInfoIcon: true,
        isShortIcon: true,
        className: "department_name",
      },
      {
        Header: "Overhead",
        accessor: "overhead",
        className: "text-center",
        Cell: cellProps => {
          const dept = cellProps.row.original
          const handleToggle = e => {
            const newVal = e.target.checked ? 1 : 0
            setDatas(prev => prev.map(d => d.id === dept.id ? { ...d, overhead: newVal } : d))
            setUpdateDepartment(dept.department_name)
            setPendingDept({ id: dept.id, name: dept.department_name, overhead: newVal, originalOverhead: dept.overhead })
            openOverheadUsers(dept.id, newVal)
          }
          return (
            <div className="form-switch form-switch-md d-flex justify-content-center">
              <input
                type="checkbox"
                className="form-check-input"
                checked={dept.overhead == 1}
                onChange={handleToggle}
              />
            </div>
          )
        },
      },
      {
        Header: "Action",
        accessor: "action",
        isInfoIcon: false,
        className: "action-width-roles text-center",
        Cell: cellProps => {
          const onDeleteDepartment = async () => {
            try {
              setLoading(true)
              const formData = new FormData()
              formData.append("user_id", localStorage.getItem("auth_id"))
              formData.append("module_id", 70)
              const permissionResponse = await axios({
                method: "post",
                url: `${configure.nodeApi}/user_permission`,
                data: formData,
                headers: {
                  Accept: "application/json",
                  "Content-Type": "multipart/form-data",
                },
              })
              if (permissionResponse) {
                setLoading(false)
                if (
                  permissionResponse.data.data.india[5] == 1 ||
                  permissionResponse.data.data.uk[5] == 1
                ) {
                  Swal.fire({
                    title: "Are you sure?",
                    text: "You want to delete this department !",
                    icon: "warning",
                    showCancelButton: true,
                  }).then(async willDelete => {
                    if (willDelete.isConfirmed) {
                      setLoading(true)
                      const formData = new FormData()
                      formData.append(
                        "department_id",
                        cellProps.row.original.id
                      )
                      try {
                        const response = await axios({
                          method: "post",
                          url: `${configure.nodeApi}/deleteDepartments`,
                          data: formData,
                          headers: {
                            Accept: "application/json",
                            "Content-Type": "multipart/form-data",
                          },
                        }).then(response => {
                          Swal.fire({
                            icon: "success",
                            text: "Department deleted successfully",
                          }).then(data => {
                            setDatas(response.data.data)
                          })
                          setLoading(false)
                        })
                      } catch (err) {
                        Swal.fire({
                          icon: "error",
                          text: "Something went wrong",
                        })
                        setLoading(false)
                      }
                    }
                  })
                } else {
                  setAccessDenied(true)
                }
              }
            } catch (error) {
              console.log(error)
            }
          }
          const onEditDepartment = async () => {
            try {
              setLoading(true)
              const formData = new FormData()
              formData.append("user_id", localStorage.getItem("auth_id"))
              formData.append("module_id", 70)
              const permissionResponse = await axios({
                method: "post",
                url: `${configure.nodeApi}/user_permission`,
                data: formData,
                headers: {
                  Accept: "application/json",
                  "Content-Type": "multipart/form-data",
                },
              })
              if (permissionResponse) {
                setLoading(false)
                if (
                  permissionResponse.data.data.india[4] == 1 ||
                  permissionResponse.data.data.uk[4] == 1
                ) {
                  setEditModal(true)
                  setDepartmentId(cellProps.row.original.id)
                  setUpdateDepartment(cellProps.row.original.department_name)
                  setEditOverhead(cellProps.row.original.overhead || 0)
                } else {
                  setAccessDenied(true)
                }
              }
            } catch (error) {
              setLoading(false)
              console.log(error)
            }
          }

          return (
            <div>
              <button
                onClick={() => onEditDepartment()}
                className="btn action-btn btn-sm me-1 btn-outline-secondary"
              >
                <i className="fas fa-pencil-alt"></i>
              </button>
              <a
                onClick={() => onDeleteDepartment()}
                className="btn btn-sm action-btn btn-danger"
              >
                <i className="fas fa-trash-alt"></i>
              </a>
            </div>
          )
        },
      },
    ],
    []
  )

  const [data, setDatas] = useState([])

  useEffect(() => {
    fetch()
  }, [])

  const fetch = async () => {
    setLoading(true)
    try {
      const response = await axios({
        method: "get",
        url: `${configure.nodeApi}/departments`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(response => {
        setDatas(response.data.data.department)
        setLoading(false)
      })
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state
  useEffect(() => setPageSize(50), [])

  const onAddDepartment = async () => {
    try {
      setLoading(true)
      const formData = new FormData()
      formData.append("user_id", localStorage.getItem("auth_id"))
      formData.append("module_id", 70)
      const permissionResponse = await axios({
        method: "post",
        url: `${configure.nodeApi}/user_permission`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      if (permissionResponse) {
        setLoading(false)
        if (
          permissionResponse.data.data.india[3] == 1 ||
          permissionResponse.data.data.uk[3] == 1
        ) {
          setAddModal(true)
        } else {
          setAccessDenied(true)
        }
      }
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const handleAdd = async e => {
    e.preventDefault()
    setLoading(true)
    const formData = new FormData()
    formData.append("department", department)
    formData.append("overhead", addOverhead)
    try {
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/addDepartments`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(response => {
        setLoading(false)
        setDatas(response.data.data)
        setAddModal(false)
        setAddOverhead(0)
        Swal.fire({
          icon: "success",
          text: "Department added successfully",
        })
      })
    } catch (err) {
      setLoading(false)
      Swal.fire({
        icon: "error",
        text: "Something went wrong",
      })
    }
  }

  const handleCancel = () => {
    setDepartment("")
    setAddModal(false)
  }

  const handleEdit = async e => {
    e.preventDefault()

    const onUsers = deptUsers.filter(u => u.overhead == 1)
    const onCount = onUsers.length

    let html = ""
    if (editOverhead == 1) {
      html =
        onCount > 0
          ? `Overhead is <b>ON</b> for the <b>${updateDepartment}</b> department.<br><br>` +
            `<b>${onCount}</b> staff member${onCount > 1 ? "s" : ""} ` +
            `(<b>${onUsers.map(u => u.alias_name || u.name).join(", ")}</b>) ` +
            `will be included in overhead calculations.`
          : `Overhead is <b>ON</b> for the <b>${updateDepartment}</b> department.<br><br>` +
            `No staff members are currently marked as overhead. You can manage them using the <b>Manage Users</b> option.`
    } else {
      html =
        `Overhead is <b>OFF</b> for the <b>${updateDepartment}</b> department.<br><br>` +
        `All staff in this department will be <b>excluded</b> from overhead calculations.`
    }

    const confirm = await Swal.fire({
      title: "Confirm Save",
      html,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Yes, Save",
      cancelButtonText: "Cancel",
    })
    if (!confirm.isConfirmed) return

    setLoading(true)
    const formData = new FormData()
    formData.append("department_id", departmentId)
    formData.append("department", updateDepartment)
    formData.append("overhead", editOverhead)
    try {
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/editDepartments`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(response => {
        setDatas(response.data.data)
        setEditModal(false)
        setEditOverhead(0)
        setDeptUsers([])
        Swal.fire({
          icon: "success",
          text: "Department edited successfully.",
        })
        setLoading(false)
      })
    } catch (err) {
      setLoading(false)
      Swal.fire({
        icon: "error",
        text: "Something went wrong",
      })
    }
  }

  const handleOverheadToggle = (userId, newVal) => {
    setDeptUsers(prev =>
      prev.map(u => (u.id === userId ? { ...u, overhead: newVal } : u))
    )
  }

  const handleOverheadSave = async () => {
    if (!pendingDept) return

    const onUsers = deptUsers.filter(u => u.overhead == 1)
    const onCount = onUsers.length

    const html = pendingDept.overhead == 1
      ? onCount > 0
        ? `Overhead is <b>ON</b> for <b>${pendingDept.name}</b> department.<br><br>` +
          `<b>${onCount}</b> staff member${onCount > 1 ? "s" : ""} ` +
          `(<b>${onUsers.map(u => u.alias_name || u.name).join(", ")}</b>) ` +
          `will be included in overhead calculations.`
        : `Overhead is <b>ON</b> for <b>${pendingDept.name}</b> department.<br><br>` +
          `No staff members are currently marked as overhead.`
      : `Overhead is <b>OFF</b> for <b>${pendingDept.name}</b> department.<br><br>` +
        `All staff will be excluded from overhead calculations.`

    const confirm = await Swal.fire({
      title: "Save Overhead Settings",
      html,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Yes, Save",
      cancelButtonText: "Cancel",
    })
    if (!confirm.isConfirmed) return

    setLoading(true)
    try {
      const updates = deptUsers.map(u => ({ user_id: u.id, overhead: u.overhead }))
      await axios({
        method: "put",
        url: `${configure.nodeApi}/allUsers/bulkUpdateOverhead`,
        data: {
          dept_id: pendingDept.id,
          dept_overhead: pendingDept.overhead,
          updates,
        },
        headers: { Accept: "application/json", "Content-Type": "application/json" },
      })
      setOverheadModal(false)
      setDeptUsers([])
      setPendingDept(null)
      Swal.fire({ icon: "success", text: "Overhead settings saved successfully." })
    } catch (err) {
      console.log(err)
      Swal.fire({ icon: "error", text: "Something went wrong. Please try again." })
    }
    setLoading(false)
  }

  return (
    <>
      <div>
        {isLoading && <Loader />}
        <Row className="ms-0 pe-0">
          <Col lg={12} className="p-0">
            <Card>
              <CardBody>
                <div>
                  <div
                    className={`flex-column fixed-buttons ${
                      fixedContent ? "d-flex" : "d-none"
                    }`}
                  >
                    <button
                      onClick={() => onAddDepartment()}
                      className="btn btn-purple  fix-btn"
                    >
                      <i className="fas fa-plus me-2 icon-size"></i>
                      <span>Department</span>
                    </button>
                    <a
                      onClick={() => navigate(-1)}
                      className="btn btn-red  fix-btn"
                    >
                      <i className="dripicons-cross me-2 icon-center"></i>
                      <span>Cancel</span>
                    </a>
                  </div>
                  <Row className="mb-2">
                    <Col>
                      <select
                        className=" form-select"
                        style={{ width: "100px" }}
                        value={pageSize}
                        onChange={e => setPageSize(e.target.value)}
                      >
                        {[10, 20, 30, 40, 50].map(pageSize => (
                          <option key={pageSize} value={pageSize}>
                            Show {pageSize}
                          </option>
                        ))}
                      </select>
                    </Col>
                    <Col md={8} className="d-flex justify-content-end">
                      <div className="me-4">
                        <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
                          <div className="position-relative">
                            <label
                              htmlFor="search-bar-0"
                              className="search-label"
                            >
                              <span id="search-bar-0-label" className="sr-only">
                                Search this table
                              </span>
                              <input
                                onChange={e => setGlobalFilter(e.target.value)}
                                id="search-bar-0"
                                type="text"
                                className=" form-control rounded h-100"
                                placeholder={` Search...`}
                                value={globalFilter || ""}
                              />
                            </label>
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>
                      <div className="">
                        <button
                          onClick={() => onAddDepartment()}
                          className=" btn btn-save btn-label"
                        >
                          <i className="fas fa-plus me-2 icon-size label-icon"></i>
                          Department
                        </button>
                        <a
                          onClick={() => navigate(-1)}
                          className=" btn ms-md-2 btn-red btn-label"
                        >
                          <i className="dripicons-cross me-2 icon-center label-icon"></i>
                          CANCEL
                        </a>
                      </div>
                    </Col>
                  </Row>
                  <div className="row">
                    <div className="col-md-4 d-flex justify-content-center">
                      <div className={`${fixedSideImg ? "departImg" : ""}`}>
                        <img
                          src={departmentImg}
                          alt="departmentImg"
                          className="w-100"
                        />
                      </div>
                    </div>
                    <div className="col-md-8 pt-4">
                      <Table
                        className="table table-bordered mt-4"
                        {...getTableProps()}
                      >
                        <thead
                          className={`${(fixedContent && page.length >= 10) ? "fixed-csetting-header" : ""
                          }`}
                        >
                          {headerGroups.map((headerGroup, i) => (
                            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                              {headerGroup.headers.map((column, index) => (
                                <th
                                  key={index}
                                  className={`${column.className} customShortIcon`}
                                  {...column.getHeaderProps(
                                    column.getSortByToggleProps()
                                  )}
                                >
                                  {column.render("Header")}

                                  {column.isInfoIcon ? (
                                    <a
                                      onClick={() => {
                                        if (
                                          column.Header == "Department Name"
                                        ) {
                                          setViewModal(true)
                                        } else if (column.Header == "Action") {
                                          setActionModal(true)
                                        }
                                      }}
                                    >
                                      <i
                                        title="info"
                                        className="bx bx-info-circle ms-1 info-icon"
                                      ></i>
                                    </a>
                                  ) : null}

                                  {column.isShortIcon && (
                                    <span
                                      onClick={() =>
                                        column.getSortByToggleProps().onClick()
                                      }
                                      className="ms-2 cursor-pointer"
                                    >
                                      <i
                                        title="Ascending"
                                        className={`bi bi-arrow-up info-icon ${
                                          column.isSorted &&
                                          !column.isSortedDesc
                                            ? "text-dark"
                                            : ""
                                        }`}
                                      ></i>
                                      <i
                                        title="Descending"
                                        className={`bi bi-arrow-down info-icon ${
                                          column.isSorted && column.isSortedDesc
                                            ? "text-dark"
                                            : ""
                                        }`}
                                      ></i>
                                    </span>
                                  )}
                                </th>
                              ))}
                            </tr>
                          ))}
                        </thead>

                        <tbody {...getTableBodyProps()}>
                          {page.map((row, i) => {
                            prepareRow(row)
                            return (
                              <tr
                                className="row-hover"
                                {...row.getRowProps()}
                                key={i}
                              >
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td
                                      className={cell.column.className}
                                      key={index}
                                      {...cell.getCellProps()}
                                    >
                                      {cell.render("Cell")}
                                    </td>
                                  )
                                })}
                              </tr>
                            )
                          })}
                          {page.length == 0 && (
                            <tr>
                              <td className="text-center" colSpan={10}>
                                No Data Found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                  {/* Pagination */}
                  <Row className="justify-content-md-end justify-content-center align-items-center">
                    <NewPagination
                      gotoPage={gotoPage}
                      canPreviousPage={canPreviousPage}
                      canNextPage={canNextPage}
                      pageIndex={pageIndex}
                      pageOptions={pageOptions}
                      pageSize={pageSize}
                      page={page}
                      data={data}
                    />
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Add Department Modal */}
      <Modal
        isOpen={add_modal}
        toggle={() => {
          tog_center()
        }}
        centered
        size="xl"
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Add Department</h5>
          <button
            type="button"
            onClick={() => setAddModal(false)}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Form onSubmit={handleAdd}>
            <Row>
              <div className="col-5">
                <img src={departmentImg} className="img-fluid" />
              </div>
              <div className="col-7 d-flex flex-column align-items-start justify-content-center gap-4">
                <div>
                  <h3>Add Department Details</h3>
                </div>
                <div className="col-12">
                  <label htmlFor="">
                    Department Name
                    <span className="text-danger">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Department Name"
                    className="form-control"
                    required
                    onChange={e => setDepartment(e.target.value)}
                  />
                </div>
                <div className="col-12 d-flex align-items-center gap-3">
                  <label className="mb-0 fw-medium">Overhead</label>
                  <div className="form-switch form-switch-md">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={addOverhead == 1}
                      onChange={e => setAddOverhead(e.target.checked ? 1 : 0)}
                    />
                  </div>
                </div>
              </div>
            </Row>
            <div className="border-bottom my-3"></div>
            <div className="text-end">
              <button className=" btn btn-purple btn-label">
                <i className="fas fa-save me-2 icon-size label-icon"></i>
                Save
              </button>
              <button
                type="button"
                onClick={() => setAddModal(false)}
                className=" btn ms-md-2 btn-red btn-label"
              >
                <i className="dripicons-cross me-2 icon-center label-icon"></i>
                CANCEL
              </button>
            </div>
          </Form>
        </div>
      </Modal>

      {/* Edit modal */}
      <Modal
        isOpen={edit_modal}
        toggle={() => {
          tog_center()
        }}
        centered
        size="xl"
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Edit Department</h5>
          <button
            type="button"
            onClick={() => {
              setDepartmentId("")
              setUpdateDepartment("")
              setEditOverhead(0)
              setDeptUsers([])
              setEditModal(false)
            }}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Form onSubmit={handleEdit}>
            <Row>
              <div className="col-5">
                <img src={EditDepartment} className="img-fluid" />
              </div>
              <div className="col-7 d-flex flex-column align-items-start justify-content-center gap-4">
                <div>
                  <h3>Edit Department Details</h3>
                </div>
                <div className="col-12">
                  <label htmlFor="">
                    Department Name
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Department Name"
                    className="form-control"
                    required
                    value={updateDepartment}
                    onChange={e => setUpdateDepartment(e.target.value)}
                  />
                </div>
                <div className="col-12 d-flex align-items-center gap-3">
                  <label className="mb-0 fw-medium">Overhead</label>
                  <div className="form-switch form-switch-md">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={editOverhead == 1}
                      onChange={e => {
                        const val = e.target.checked ? 1 : 0
                        setEditOverhead(val)
                        setPendingDept({ id: departmentId, name: updateDepartment, overhead: val })
                        openOverheadUsers(departmentId, val)
                      }}
                    />
                  </div>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-info"
                    onClick={() => {
                      setPendingDept({ id: departmentId, name: updateDepartment, overhead: editOverhead })
                      openOverheadUsers(departmentId, editOverhead, true)
                    }}
                  >
                    <i className="fas fa-users me-1"></i>
                    Manage Users
                  </button>
                </div>
              </div>
            </Row>
            <div className="border-bottom my-3"></div>
            <div className="text-end">
              <button className=" btn btn-purple btn-label">
                <i className="fas fa-save me-2 icon-size label-icon"></i>
                Save
              </button>
              <a
                onClick={() => {
                  setDepartmentId("")
                  setUpdateDepartment("")
                  setEditOverhead(0)
                  setDeptUsers([])
                  setEditModal(false)
                }}
                className=" btn ms-md-2 btn-red btn-label"
              >
                <i className="dripicons-cross me-2 icon-center label-icon"></i>
                CANCEL
              </a>
            </div>
          </Form>
        </div>
      </Modal>

      {/* Overhead Users Popup */}
      <Modal
        isOpen={overheadModal}
        toggle={() => setOverheadModal(false)}
        centered
        size="md"
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            Overhead Users — {updateDepartment}
          </h5>
          <button
            type="button"
            onClick={() => setOverheadModal(false)}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">&times;</span>
          </button>
        </div>
        <div className="modal-body" style={{ maxHeight: "420px", overflowY: "auto" }}>
          {loadingUsers ? (
            <div className="text-center py-4">
              <div className="spinner-border text-purple" role="status" />
            </div>
          ) : deptUsers.length === 0 ? (
            <p className="text-center text-muted py-3">No staff found in this department.</p>
          ) : (
            deptUsers.map(user => (
              <div
                key={user.id}
                className="d-flex align-items-center justify-content-between py-2 border-bottom"
              >
                <div className="d-flex align-items-center gap-2">
                  {user.avatar ? (
                    <img
                      src={`${configure.imgUrl}/${user.avatar}`}
                      alt={user.name}
                      className="rounded-circle"
                      style={{ width: 36, height: 36, objectFit: "cover" }}
                      onError={e => { e.target.style.display = "none" }}
                    />
                  ) : (
                    <div
                      className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-white"
                      style={{ width: 36, height: 36, fontSize: 14, flexShrink: 0 }}
                    >
                      {user.name?.charAt(0)?.toUpperCase()}
                    </div>
                  )}
                  <span className="fw-medium">{user.alias_name || user.name}</span>
                </div>
                <div className="form-switch form-switch-md">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={user.overhead == 1}
                    onChange={e => handleOverheadToggle(user.id, e.target.checked ? 1 : 0)}
                  />
                </div>
              </div>
            ))
          )}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-purple btn-sm"
            onClick={handleOverheadSave}
          >
            Save
          </button>
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={() => {
              if (pendingDept?.originalOverhead !== undefined) {
                setDatas(prev => prev.map(d => d.id === pendingDept.id ? { ...d, overhead: pendingDept.originalOverhead } : d))
              }
              setOverheadModal(false)
              setDeptUsers([])
              setPendingDept(null)
            }}
          >
            Cancel
          </button>
        </div>
      </Modal>

      {/* ------------ */}
      <Modal
        isOpen={view_modal}
        toggle={() => {
          tog_center()
        }}
        className="bd-info-popup"
        centered
      >
        <div className="modal-header bd-head-info">
          <h5 className="modal-title mt-0">
            <i className="dripicons-information bd-transform-icon pr-10 text-red"></i>
            Department Name Info
          </h5>
        </div>
        <div className="modal-body pb-0">
          <div className="d-flex">
            <div className="col-5 pr-30">
              <div>
                <img src={InfoGif} className="w-100" />
              </div>
            </div>
            <div className="mt-20 ">
              <div>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Cras
                  mattis consectetur purus sit amet fermentum. Cras justo odio,
                  dapibus ac facilisis in, egestas eget quam. Morbi leo risus,
                  porta ac consectetur ac, vestibulum at eros.
                </p>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Praesent
                  commodo cursus magna, vel scelerisque nisl consectetur et.
                  Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                  auctor.
                </p>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Praesent
                  commodo cursus magna, vel scelerisque nisl consectetur et.
                  Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                  auctor.
                </p>
                <p>
                  <i className="fas fa-angle-double-right pr-10"></i> Praesent
                  commodo cursus magna, vel scelerisque nisl consectetur et.
                  Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                  auctor.
                </p>
                <div className="text-center mt-40">
                  <button
                    type="button"
                    className="btn btn-success "
                    onClick={() => setViewModal(false)}
                  >
                    I Understood
                    <i className="dripicons-thumbs-up pl-10"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* Access Denied */}
      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </>
  )
}

export default Department
